module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [(_vm.success) ? _c('h3', {
    staticClass: "thanksfull-title",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("\n\t\t¡Gracias, " + _vm._s(_vm.fullName) + " por tu compra!\n\t")]) : _c('h3', {
    staticClass: "thanksfull-title"
  }, [_vm._v("\n\t\t¡Lo sentimos, el pago no pudo ser procesado, su pedido ha sido cancelado.!\n\t")]), _vm._v(" "), _c('order-data', {
    attrs: {
      "amount": _vm.order.subtotal,
      "currency-symbol": _vm.getCurrencySymbol,
      "date": _vm.order.createdAt,
      "id": _vm.order.id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a62f2728","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-header.vue
// module id = 1151
// module chunks = 2